import React, { useState } from "react";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { toast } from "sonner";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { CONTACT } from "@/data/site";
import Seo from "@/components/Seo";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try { await api.post("/contact", form); toast.success("Message sent! We'll be in touch soon."); setForm({ name: "", email: "", phone: "", message: "" }); }
    catch { toast.error("Something went wrong. Please try again."); }
    finally { setSending(false); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div data-testid="contact-page">
      <Seo
        title="Contact K.O Chef & Catering | Naples, Bonita Springs & Fort Myers FL"
        description="Get in touch with K.O CHEF & CATERING for premium catering & private chef services in Southwest Florida. Call, email info@kochefcatering.com, or send us a message."
        path="/contact"
      />
      <PageHero overline="Contact" title="Let's Talk"
        subtitle="Reach out to plan your next unforgettable event."
        image="https://images.unsplash.com/photo-1583338917496-7ea264c374ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-20 md:py-28">
        <div className="container-lux grid grid-cols-1 lg:grid-cols-2 gap-16">
          <Reveal>
            <p className="overline mb-4">Get in Touch</p>
            <h2 className="text-4xl font-light text-white mb-8">We can't wait to hear from you.</h2>
            <div className="space-y-7">
              <div className="flex gap-4"><MapPin className="w-5 h-5 text-gold shrink-0 mt-1" /><div><p className="text-white">Service Area</p><p className="text-white/55 text-sm">{CONTACT.areas}</p></div></div>
              <div className="flex gap-4"><Phone className="w-5 h-5 text-gold shrink-0 mt-1" /><div><p className="text-white">Call Us</p><p className="text-white/55 text-sm">{CONTACT.phoneEnName} (English): {CONTACT.phoneEn}</p><p className="text-white/55 text-sm">{CONTACT.phoneEsName} (Español): {CONTACT.phoneEs}</p></div></div>
              <div className="flex gap-4"><Mail className="w-5 h-5 text-gold shrink-0 mt-1" /><div><p className="text-white">Email</p><p className="text-white/55 text-sm">{CONTACT.email}</p></div></div>
              <div className="flex gap-4"><Clock className="w-5 h-5 text-gold shrink-0 mt-1" /><div><p className="text-white">Business Hours</p>{CONTACT.hours.map((h) => <p key={h.d} className="text-white/55 text-sm">{h.d}: {h.h}</p>)}</div></div>
              <div className="flex gap-4">
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 border border-white/15 flex items-center justify-center text-white/70 hover:border-gold hover:text-gold transition-colors" data-testid="contact-ig"><Instagram className="w-5 h-5" /></a>
                <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 border border-white/15 flex items-center justify-center text-white/70 hover:border-gold hover:text-gold transition-colors" data-testid="contact-fb"><Facebook className="w-5 h-5" /></a>
              </div>
            </div>
            <div className="mt-10 border border-white/10">
              <iframe title="map" width="100%" height="260" style={{ border: 0, filter: "grayscale(1) invert(0.9)" }} loading="lazy"
                src="https://www.google.com/maps?q=Naples,Florida&output=embed" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <form onSubmit={submit} className="border border-white/10 p-8 md:p-10 space-y-7" data-testid="contact-form">
              <h3 className="text-2xl font-light text-white">Send a Message</h3>
              <input required value={form.name} onChange={set("name")} placeholder="Full Name" className="lux-input" data-testid="contact-name" />
              <input required type="email" value={form.email} onChange={set("email")} placeholder="Email" className="lux-input" data-testid="contact-email" />
              <input value={form.phone} onChange={set("phone")} placeholder="Phone" className="lux-input" data-testid="contact-phone" />
              <textarea required value={form.message} onChange={set("message")} placeholder="Tell us about your event…" rows={5} className="lux-input resize-none" data-testid="contact-message" />
              <button disabled={sending} className="btn-gold w-full" data-testid="contact-submit">{sending ? "Sending…" : "Send Message"}</button>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
